import { getRandomIntegerInclusive } from './getRandomIntegerInclusive';

export const getRandomString = (minCharacters: number, maxCharacters: number) => {
  return Array(getRandomIntegerInclusive(minCharacters, maxCharacters))
    .fill(null)
    .map(() => 'M')
    .join('');
};
